import React, { useEffect, useState } from 'react';
import Api from '../../../Api';
import sendRequest from '../../../helpers/sendRequest';
import MyCheckBox from '../../../components/MyCheckbox';
import MyButton from '../../../components/MyButton';
import cities from '../../Cities';

function SelectAdditionalCities({
  setValue, setTempComponentState, countryId, initValue = [],
}) {
  const [thisCities, setThisCities] = useState([]);
  const [selected, setSelected] = useState(initValue);

  const handleClick = (item) => {
    if (selected.some((i) => i._id === item._id)) {
      setSelected((prev) => prev.filter((el) => el._id !== item._id));
    } else {
      setSelected((prev) => [...prev, item]);
    }
  };

  const getThisCities = async (id) => {
    const data = await sendRequest({
      request: Api.getCities,
      payload: { country_id: id },
      warnErrorText: 'while getting this cities',
    });

    if (data?.status !== 'ok') return;

    setThisCities(data.cities);
  };

  const handleSubmit = () => {
    setValue(selected);
    setTempComponentState(null);
  };

  useEffect(() => {
    if (countryId) {
      getThisCities(countryId).then();
    }
  }, [countryId]);

  return (
    <div className="temp_container">
      <p className="temp_container_title">Выберите города</p>
      <div className="temp_container_scroll with_button">
        {thisCities.map((item) => (
          <MyCheckBox
            key={item._id}
            value={selected.some((i) => i._id === item._id)}
            onClick={() => handleClick(item)}
            text={item.name}
            wrapperClassName="temp_container_item"
          />
        ))}
      </div>

      <MyButton onClick={handleSubmit} text="Ок" className="temp_container_button" />
    </div>
  );
}

export default SelectAdditionalCities;
